// services/AuthService.interface.ts

export interface IAuthService {
  refresh(dto: ContactRefreshResponseDTO): Promise<ContactTokens>
  logout(): Promise<void>
}

export interface ContactTokens {
  accessToken: string
  idToken: string
  refreshToken: string
}

export interface UserInfo {
  email: string
  first_name: string
  last_name: string
  gender: GenderEnum | string
  postal_code: string
  city: string
  phone_number: string
  phone_code: string
  country: string
  address: string
  site_locale: string
  iresa_id: string
  accept_conditions: boolean
  subscribe_newsletter: boolean
  company?: string
}

export interface ContactRefreshResponseDTO {
  userInfo: UserInfo
  tokens: ContactTokens
}

export interface ContactEditDTO {
  address: string
  country: string
  gender: GenderEnum
  postal_code: string
  city: string
  last_name: string
  first_name: string
  phone_number: string
  phone_code: string
  subscribe_newsletter?: boolean
  cgos_agent_id?: string
}

export interface ContactLoginDTO {
  email: string
  password: string
}

export interface ContactNewPasswordDTO {
  token: string
  newPassword: string
}

export interface ContactRegisterDTO {
  accept_conditions: boolean
  subscribe_newsletter: boolean
  address: string
  email: string
  password: string
  country: string
  gender: GenderEnum
  postal_code: string
  city: string
  last_name: string
  first_name: string
  phone_number: string
  phone_code: string
  cgos_agent_id?: string
}

export interface ContactResetPasswordDTO {
  email: string
  returnUrl: string
}

export interface ContactSearchDTO {
  email: string
}

export interface ContactLoginResponseDTO {
  userInfo: UserInfo
  tokens: ContactTokens
  company: string | null
}

export interface ContactNewPasswordResponseDTO {
  // Add fields if necessary
}

export interface ContactRegisterResponseDTO {
  userInfo: UserInfo
  tokens: ContactTokens
}

export interface ContactResetPasswordResponseDTO {
  // Add fields if necessary
}

export interface ContactSearchResponseDTO {
  userExists: boolean
}

export type UpdateUserInfoDTO = Omit<UserInfo, 'email'>

export const enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
  None = '',
  OTHER = 'OTHER',
}
